import { useEffect, useState } from 'react';

import { selectEmbedParams, selectIsInAppMode, useStore } from '~/store';
import { getCookieByName } from '~/utils/cookies';
import { stringify } from '~/utils/qs';
import { send } from './utils';

const ITEM_ID = 'af9-comm-ents-id-a-a40519d737af70860';
const CONTENT_TYPE = 'article';

export const Cooladata = () => {
  const isInAppMode = useStore(selectIsInAppMode);
  const embed = useStore(selectEmbedParams);
  const { canonicalUrl, channelId, channelDepth, isOpen } = embed;

  const srcBase = 'https://www.mako.co.il/collab/domo/statistics.html';
  const vcmId = ITEM_ID;
  const contentType = CONTENT_TYPE;
  const parentURL = embed.canonicalUrl;
  const referrer = embed.friendlyUrl;
  const [params, setParams] = useState<Record<string, string> | null>(null);

  const src = params ? `${srcBase}?${stringify(params)}` : null;

  useEffect(() => {
    (async () => {
      if (isOpen) {
        if (isInAppMode) {
          send('page_view', {
            item_id: ITEM_ID,
            channel_id: channelId,
            // TODO: temporarily we desided not to send 'channel_depth'
            // because we are not sure if the Client can pass it via URL
            // channel_depth: channelDepth,
            page_url: canonicalUrl,
            content_type: CONTENT_TYPE,
          });
        } else {
          let attempts = 0;
          let click_id = '';

          while (attempts < 10 && !click_id) {
            click_id = getCookieByName('click_id') ?? '';
            if (!click_id) {
              void (await new Promise(resolve => setTimeout(resolve, 1000)));
              attempts++;
            }
            console.log('get click_id attempt:', attempts);
          }

          setParams({
            vcmId,
            contentType,
            channelId,
            parentURL,
            referrer,
            // this cookie is 10sec-living, needs to be updated right after isOpen = true
            click_id,
          });
        }
      } else {
        setParams(null);
      }
    })().catch((error: unknown) => {
      console.error('Error in Cooladata:', error);
    });
  }, [contentType, vcmId, parentURL, referrer, canonicalUrl, channelId, channelDepth, isInAppMode, isOpen]);

  if (!isOpen || isInAppMode) {
    return null;
  }

  return src && <object type="text/html" data={src} width="0" height="0" style={{ position: 'absolute' }} />;
};
